import { Outlet } from 'react-router';

import { Logo02Icon } from '@/assets/icons';
import { BackgroundVideoPlayer } from '@/components/common';

const AuthLayout = () => {
  return (
    <main className="relative flex h-screen w-screen flex-1 items-center justify-center dark">
      <BackgroundVideoPlayer />

      <div className="z-50 flex flex-col h-full w-full items-center justify-center gap-10 bg-[linear-gradient(180deg,rgba(8,52,116,0)_20%,#010A17_100%)] shadow-[20px_20px_100px_0px_#1897FF33_inset,-20px_-20px_100px_0px_#1897FF33_inset]">
        <div className="flex flex-col items-center gap-10 -mt-[88px]">
          <Logo02Icon />
          <Outlet />
        </div>
      </div>
    </main>
  );
};

export { AuthLayout };
